import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuth, selectUserRole } from '../features/authSlice';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { isAuthenticated, isLoading } = useSelector(selectAuth);
  const effectiveRole = useSelector(selectUserRole);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(effectiveRole)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
